//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import {PublicAppLayout} from 'app_components/layouts/public'
import BannerTextPrimaryCommon from 'app_components/commons/bannertextprimary'
import AllThingsModule from 'app_components/modules/academic/allthings'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../moocsScreen.scss'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'

// @ADD Component types
interface IMoocsScreenLayoutProps {}

const MoocsScreenLayout: React.FC<IMoocsScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <PublicAppLayout>
      <div className="moocs-screen--layout">
        <TextComponent type='title' as='h2' textTransform='none'>Mooc</TextComponent>
        <AllThingsModule type={'moocs'}/>
      </div>
    </PublicAppLayout>
  )
}

export default MoocsScreenLayout
